import { useEffect } from "react";

const ConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Confirmation",
    message = "Are you sure you want to proceed?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    type = "info", // 'info' | 'warning' | 'danger' | 'success'
}) => {
    useEffect(() => {
        const handleEsc = (e) => e.key === "Escape" && onClose();
        if (isOpen) document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const colorMap = {
        info: "from-blue-500 to-indigo-500",
        warning: "from-amber-400 to-orange-500",
        danger: "from-rose-500 to-red-600",
        success: "from-emerald-500 to-green-600",
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[2px] p-4">
            <div className="bg-white rounded-2xl w-full max-w-sm sm:max-w-md shadow-xl animate-fadeIn border border-gray-200">
                <div
                    className={`rounded-t-2xl bg-gradient-to-r ${colorMap[type]} text-white px-5 py-4`}
                >
                    <h3 className="text-lg font-semibold">{title}</h3>
                </div>

                <div className="p-5 text-center">
                    <p className="text-gray-700 text-sm sm:text-base">{message}</p>
                </div>

                <div className="flex justify-end space-x-3 px-5 py-4 bg-gray-50 rounded-b-2xl">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 transition text-sm sm:text-base"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        className={`px-4 py-2 rounded-lg text-white bg-gradient-to-r ${colorMap[type]} hover:opacity-90 transition text-sm sm:text-base`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;